var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildRapport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5077 6.57734C16.5147 3.81527 14.0277 1.86114 11.1029 1.54481C8.17812 1.22848 5.32897 2.60547 3.76539 5.09102C2.20182 7.57657 2.19828 10.7344 3.7563 13.2234L1.5 17.95L6.23806 15.6995C7.11091 16.2417 8.08408 16.6035 9.09981 16.7633",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83313 6.57983V7.84318",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8997 6.57983V7.84318",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10403 12.6861C8.00427 12.2979 7.14312 11.4291 6.76666 10.3278",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9666 9.73827C17.7457 9.73014 19.3635 10.7653 20.0977 12.3816C20.8319 13.9979 20.5455 15.8936 19.3663 17.2223L19.9329 20.4767L16.9774 18.6592C15.2809 19.0476 13.5113 18.4321 12.425 17.0757C11.3386 15.7193 11.1276 13.8619 11.8822 12.2974C12.6368 10.733 14.2235 9.7382 15.9641 9.73827H15.9666Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1664 13.8441C13.9915 13.8441 13.8497 13.9855 13.8497 14.16C13.8497 14.3344 13.9915 14.4758 14.1664 14.4758C14.3413 14.4758 14.483 14.3344 14.483 14.16C14.483 13.9855 14.3413 13.8441 14.1664 13.8441",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 13.8441C17.1581 13.8441 17.0163 13.9855 17.0163 14.16C17.0163 14.3344 17.1581 14.4758 17.333 14.4758C17.5078 14.4758 17.6496 14.3344 17.6496 14.16C17.6496 13.9855 17.5078 13.8441 17.333 13.8441",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildRapport);
export default __webpack_public_path__ + "static/media/BuildRapport.daae686d3cfbb46fd49ebb6f2353ec5c.svg";
export { ForwardRef as ReactComponent };